import styled from "styled-components";
import { font, theme } from "styles";

export const NavigationLinkText = styled("span")`
  position: relative;
  font-size: 14px;
  font-weight: ${font.weight.bold};
  color: ${theme.navigationLinkText.fontColor};
`;
